'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseAppCookieLogin2 = require('./BaseAppCookieLogin');

var _BaseAppCookieLogin3 = _interopRequireDefault(_BaseAppCookieLogin2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// For now we need to pass `app` to the BaseCookieLogin class
// All api requests go to `app-api` though.
// This value gets used for cookie names.
var COOKIE_LOAD_BALANCERS = ['app'];

var HubSpotOnlyAppCookieLogin = function (_BaseAppCookieLogin) {
  _inherits(HubSpotOnlyAppCookieLogin, _BaseAppCookieLogin);

  function HubSpotOnlyAppCookieLogin(options) {
    _classCallCheck(this, HubSpotOnlyAppCookieLogin);

    var _ref = options || {},
        loginRequest = _ref.loginRequest,
        passThroughFallback = _ref.passThroughFallback;

    return _possibleConstructorReturn(this, (HubSpotOnlyAppCookieLogin.__proto__ || Object.getPrototypeOf(HubSpotOnlyAppCookieLogin)).call(this, COOKIE_LOAD_BALANCERS, loginRequest, passThroughFallback));
  }

  _createClass(HubSpotOnlyAppCookieLogin, [{
    key: 'loginRequestsInternal',
    value: function loginRequestsInternal(credentials) {
      return [this.loginRequest(credentials, 'app-api').then(function (appApiResponse) {
        return [appApiResponse];
      })];
    }
  }, {
    key: 'domainPreps',
    value: function domainPreps() {
      return [this.prepRequest('app-api')];
    }
  }]);

  return HubSpotOnlyAppCookieLogin;
}(_BaseAppCookieLogin3.default);

exports.default = HubSpotOnlyAppCookieLogin;
module.exports = exports['default'];